import type { FC } from 'react'
import React, { useEffect, useState } from 'react'
import { Input } from '../../../inputs/Input'
import type { ColorPickerInputProps } from './types'

export const ColorPickerInput: FC<ColorPickerInputProps> = ({ value, label, onChange }) => {
  const [innerValue, setInnerValue] = useState(value)
  const [isFocused, setFocus] = useState(false)

  useEffect(() => {
    if (!isFocused) {
      setInnerValue(value)
    }
  }, [value])

  const handleInputChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    setInnerValue(e.target.value)
    onChange(e.target.value)
  }

  const handleBlur = () => {
    setInnerValue(value)
    setFocus(false)
  }

  const handleFocus = () => {
    setFocus(true)
  }

  return (
    <Input
      value={innerValue}
      invalid={false}
      label={label}
      size="small"
      fullWidth
      onChange={handleInputChange}
      onBlur={handleBlur}
      onFocus={handleFocus}
    />
  )
}
